import { Chip, Typography, Grid, Button, Checkbox, FormControlLabel, Box } from "@mui/material";
import { useState } from "react";
import React from "react";

const ColumnCreator = ({ setOpen, customColumns, setCustomColumns }) => {
  const [update, setUpdate] = useState(false);

  const handleDelete = (index) => {
    const newColumns = [...customColumns];
    newColumns.splice(index, 1);
    setCustomColumns(newColumns);
    setUpdate(!update); // Toggle to trigger re-render
  };

  const handleRequiredToggle = (index) => {
    const newColumns = [...customColumns];
    // Handle both old string format and new object format
    if (typeof newColumns[index] === 'string') {
      // Convert old string format to new object format
      newColumns[index] = { name: newColumns[index], required: true };
    } else {
      // Toggle required flag
      newColumns[index] = { ...newColumns[index], required: !newColumns[index].required };
    }
    setCustomColumns(newColumns);
  };

  const getColumnName = (column) => {
    return typeof column === 'string' ? column : column.name;
  };

  const getColumnRequired = (column) => {
    return typeof column === 'string' ? false : (column.required || false);
  };

  return (
    <>
      {customColumns &&
        customColumns.length > 0 &&
        customColumns.map((column, index) => {
          const columnName = getColumnName(column);
          const isRequired = getColumnRequired(column);
          
          return (
            <React.Fragment key={index}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isRequired}
                        onChange={() => handleRequiredToggle(index)}
                      />
                    }
                    label={columnName}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    onClick={() => handleDelete(index)}
                    sx={{ minWidth: '60px' }}
                  >
                    Delete
                  </Button>
                </Box>
              </Grid>
            </React.Fragment>
          );
        })}
      
      <Grid item xs={12} sx={{ mt: 2 }}></Grid>
      
      <Grid item xs={4} align="left">
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={() => setOpen(true)}
        >
          + Add Column
        </Button>
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={3}></Grid>
      <Grid item xs={2}></Grid>
    </>
  );
};

export default ColumnCreator;
